import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
    selector: 'app-proj-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.less'],
    standalone: false
})
export class ProjSideBarComponent implements OnInit, OnDestroy {
  isOpen = false;

  constructor() { }

  ngOnInit() {
  }

  ngOnDestroy() {
  }
}
